import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=09d16144&scoped=true&"
import script from "./plain.vue?vue&type=script&lang=js&"
export * from "./plain.vue?vue&type=script&lang=js&"
import style0 from "./plain.vue?vue&type=style&index=0&id=09d16144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d16144",
  null
  
)

export default component.exports